export const getActivityColors = (activity: string) => {
    let backgroundColor = '#E6E6FA';
    let textColor = '#5D3FD3';

    switch (activity) {
        case 'Preparation':
            backgroundColor = '#e5e5e5'; // Light gray
            textColor = 'black';
            break;
        case 'Container Booking':
            backgroundColor = '#E6E6FA'; // Light purple
            textColor = '#5D3FD3';
            break;
        case 'Gate In Smelter':
            backgroundColor = '#FFE6E6'; // Light pink
            textColor = '#FF5C8D';
            break;
        case 'Start Loading':
            backgroundColor = '#F0E6FF'; // Light lavender
            textColor = '#9370DB';
            break;
        case 'Finish Loading':
            backgroundColor = '#E6F0FF'; // Light blue
            textColor = '#4682B4';
            break;
        case 'Gate Out Smelter':
            backgroundColor = '#FFF4E0'; // Light orange/amber
            textColor = '#CD7F32';
            break;
        case 'Port Gate In':
        case 'Terminal Gate In':
            backgroundColor = '#E6E6FA'; // Light purple
            textColor = '#7B68EE';
            break;
        case 'CY Check In':
            backgroundColor = '#FFE6FF'; // Light magenta
            textColor = '#9932CC';
            break;
        case 'ATD POL':
            backgroundColor = '#E0F7FF'; // Light sky blue
            textColor = '#1E90FF';
            break;
        case 'ATA POD':
            backgroundColor = '#E6FFFA'; // Light teal
            textColor = '#008B8B';
            break;
        case 'Cargo Departed':
            backgroundColor = '#E0FFFF'; // Light cyan
            textColor = '#20B2AA';
            break;
        case 'Cargo Arrived':
            backgroundColor = '#E6FFE6'; // Light green
            textColor = '#3CB371';
            break;
        default:
            break;
    }
    return { backgroundColor, textColor };
};

// Get styles using the colors
export const getActivityStyle = (activity: string) => {
    const { backgroundColor, textColor } = getActivityColors(activity);

    return {
        backgroundColor,
        color: textColor,
        borderRadius: '20px',
        padding: '2px 16px',
        fontSize: '10px',
        fontWeight: 500,
        whiteSpace: 'nowrap',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 'fit-content',

    };
};